// src/pages/Home.js
import React, { useState } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import SearchBar from '../components/SearchBar';
import PopularCourts from '../components/PopularCourts';
import Footer from '../components/Footer';
import CategoryFilter from '../components/CategoryFilter';
import UserReviewsCard from '../components/UserReview';
import Gallery from '../components/Gallery';
import { FaSearch, FaTimes } from 'react-icons/fa';
import Carousel from '../components/SearchBar';

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
//   gap: 1rem;
  padding-bottom: 4rem; // Space for fixed footer
`;
const DrawerOverlay = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
//   top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  justify-content: center;
  align-items: flex-end; /* Align content to the bottom */
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const DrawerContent = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 500px;
  min-height:500px;
  border-radius: 20px 20px 0 0; /* More rounded top corners */
  padding: 1.5rem;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;
  overflow-y: auto;
  
  @keyframes slideUp {
    from {
      transform: translateY(100%); /* Start below the screen */
    }
    to {
      transform: translateY(0); /* Slide up to the final position */
    }
  }

  /* Desktop Styles */
  @media (min-width: 768px) {
    width: 100%;
    max-width: 900px;
    position: absolute;
    bottom: 0;
    left: 10%;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  }
`;

const DrawerHeader = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
`;

const CloseIcon = styled(FaTimes)`
  cursor: pointer;
  font-size: 1.5rem;
  color: #888;
`;
const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #66bb6a;
  border-radius: 20px;
  padding: 0.5rem 1rem;
  background-color: #ffffff; /* White background for input wrapper */
  width: 100%;
  max-width: 500px; // Adjusted width limit for better responsiveness
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
`;

const Input = styled.input`
  border: none;
  outline: none;
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  color: #333333;
  background: transparent; /* Transparent background inside input */
  margin-right: 0.5rem; /* Spacing between text and icon */
`;

const SearchIcon = styled(FaSearch)`
  color: #66bb6a;
  font-size: 1.2rem;
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: #4CAF50; /* Slightly darker shade on hover */
  }
`;

const Home = () => {
    const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [selectedCity, setSelectedCity] = useState("Melvisharam");

  const toggleDrawer = () => setDrawerOpen(!isDrawerOpen);
  const selectCity = (city) => {
    setSelectedCity(city);
    toggleDrawer();
  };
  
  return (
    <HomeContainer>
      <Header />
      <Carousel />
      <CategoryFilter/>
      <PopularCourts />
      <UserReviewsCard/>
      <Gallery/>
      <Footer clickSearchIcon={toggleDrawer} />
      <DrawerOverlay isOpen={isDrawerOpen} onClick={toggleDrawer}>
        <DrawerContent onClick={(e) => e.stopPropagation()}>
          <DrawerHeader>
          {/* <span className=''>Search available courts </span> */}
            <CloseIcon onClick={toggleDrawer} />
          </DrawerHeader>
     {/* Search Field inside the carousel */}
     <InputWrapper>
      <Input placeholder="Search" />
      <SearchIcon />
    </InputWrapper>
        
          
        </DrawerContent>
      </DrawerOverlay>
    </HomeContainer>
  );
};

export default Home;
